import { Avatar, Modal, Typography } from 'antd'
import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react'
import { UserOutlined } from '@ant-design/icons';
const { Text, Paragraph } = Typography;

export const ViewHistoryComments = ({ open, setOpen, messageData, commentSpec }) => {
    const [commentsList, setCommentsList] = useState([]);

    useEffect(() => {
        if (open === true) setCommentsList(messageData)
    }, [messageData, open])

    return (

        <Modal
            open={open}
            okText='Ok'
            cancelText='Close'
            onCancel={() => setOpen(false)}
            onOk={() => setOpen(false)}
        >
            <div style={{ padding: '10px' }}>
                <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                    <Title level={5}>Comments of Spec No: <span style={{ color: '#304CB2' }}>{commentSpec}</span></Title>
                </div>

                <div className='scroll'>
                    {
                        commentsList.length > 0 &&
                        commentsList.map((ele, index) => {
                            return <div className='comment_card' key={index}>
                                <div style={{ display: 'flex', }}>
                                    <div style={{}}>
                                        <Avatar size="large" icon={<UserOutlined />} />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '15px' }}>
                                        <Text strong style={{ fontSize: '14px', color: '#000' }}>
                                            {ele.user}
                                        </Text>
                                        <Text type="secondary" style={{ fontSize: '13px', }}>
                                            {ele.created_on}
                                        </Text>
                                    </div>
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    <Paragraph style={{ marginBottom: '0px' }}>
                                        {ele.comment}
                                    </Paragraph>
                                </div>
                            </div>
                        })
                    }
                </div>

            </div>
        </Modal>
    )
}
